"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.easeIn = easeIn;
exports.easeOut = easeOut;
exports.inAndOut = inAndOut;
exports.linear = linear;
exports.upAndDown = upAndDown;

/**
 * @module ol/easing
 */

/**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */
function easeIn(t) {
  return Math.pow(t, 3);
}
/**
 * Start fast and slow down.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */


function easeOut(t) {
  return 1 - easeIn(1 - t);
}
/**
 * Start slow, speed up, and then slow down again.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */


function inAndOut(t) {
  return 3 * t * t - 2 * t * t * t;
}
/**
 * Maintain a constant speed over time.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */


function linear(t) {
  return t;
}
/**
 * Start slow, speed up, and at the very end slow down again.  This has the
 * same general behavior as {@link module:ol/easing.inAndOut}, but the final
 * slowdown is delayed.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */


function upAndDown(t) {
  if (t < 0.5) {
    return inAndOut(2 * t);
  } else {
    return 1 - inAndOut(2 * (t - 0.5));
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQTs7OztBQUlBOzs7Ozs7QUFNTSxTQUFVQSxNQUFWLENBQWlCQyxDQUFqQixFQUFrQjtFQUN0QixPQUFPQyxJQUFJLENBQUNDLEdBQUwsQ0FBU0YsQ0FBVCxFQUFZLENBQVosQ0FBUDtBQUNEO0FBRUQ7Ozs7Ozs7O0FBTU0sU0FBVUcsT0FBVixDQUFrQkgsQ0FBbEIsRUFBbUI7RUFDdkIsT0FBTyxJQUFJRCxNQUFNLENBQUMsSUFBSUMsQ0FBTCxDQUFqQjtBQUNEO0FBRUQ7Ozs7Ozs7O0FBTU0sU0FBVUksUUFBVixDQUFtQkosQ0FBbkIsRUFBb0I7RUFDeEIsT0FBTyxJQUFJQSxDQUFKLEdBQVFBLENBQVIsR0FBWSxJQUFJQSxDQUFKLEdBQVFBLENBQVIsR0FBWUEsQ0FBL0I7QUFDRDtBQUVEOzs7Ozs7OztBQU1NLFNBQVVLLE1BQVYsQ0FBaUJMLENBQWpCLEVBQWtCO0VBQ3RCLE9BQU9BLENBQVA7QUFDRDtBQUVEOzs7Ozs7Ozs7O0FBUU0sU0FBVU0sU0FBVixDQUFvQk4sQ0FBcEIsRUFBcUI7RUFDekIsSUFBSUEsQ0FBQyxHQUFHLEdBQVIsRUFBYTtJQUNYLE9BQU9JLFFBQVEsQ0FBQyxJQUFJSixDQUFMLENBQWY7RUFDRCxDQUZELE1BRU87SUFDTCxPQUFPLElBQUlJLFFBQVEsQ0FBQyxLQUFLSixDQUFDLEdBQUcsR0FBVCxDQUFELENBQW5CO0VBQ0Q7QUFDRiIsIm5hbWVzIjpbImVhc2VJbiIsInQiLCJNYXRoIiwicG93IiwiZWFzZU91dCIsImluQW5kT3V0IiwibGluZWFyIiwidXBBbmREb3duIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9lYXNpbmcuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=